import React, { useState } from "react";
import { Form, Formik } from "formik";
import { Col, Row, Button } from "react-bootstrap";
import { Modal } from "react-bootstrap";
import Cookie from "js-cookie";
import {
  getFormFields,
  newVendorAddressFields,
  newVendorContactFields,
  getInitialFormValues,
  getFormValidations,
  formatPhone,
} from "../../../Dashboard/Views/AddNewVendor/formFields";
import * as Constants from "../../../../constants/Constants";
import { httpPostAddContactExternalVendor } from "../../../../service/httpClient";
import "./style.css";

const ExternalCompanyDetailsModal = ({ closeHandler, externalVendorModal }) => {
  const [submitError, setSubmitError] = useState({
    error: false,
    message: "",
    type: "",
  });
  const [addressError, setAddressError] = useState("");
  const handleClose = () => {
    closeHandler();
  };

  newVendorAddressFields.map((item) => {
    if (item.name === "streetAddress") {
      item.margin = "5px 0px 18px 0px";
      item.length = 9;
    } else if (item.name === "suiteUnitFloor") {
      item.length = 3;
    } else if (item.name === "city") {
      item.length = 7;
    } else if (item.name === "state") {
      item.length = 5;
    } else if (item.name === "postalCode") {
      item.length = 7;
    } else if (item.name === "country") {
      item.length = 5;
    } else {
      item.length = 6;
    }
    if (item.name !== "streetAddress") {
      item.margin = "0px 0px 18px 0px";
    }

    return item;
  });
  newVendorContactFields.map((item) => {
    if (item.name === "firstName") {
      item.length = 8;
    } else if (item.name === "lastName") {
      item.length = 4;
    } else if (item.name === "corpEmailId") {
      item.length = 12;
      item.readOnly = true;
    } else if (item.name === "phoneNumber") {
      item.length = 8;
    } else if (item.name === "extension") {
      item.length = 4;
    } else {
      item.length = 6;
    }
    item.marginBottom = "0px 0px 18px 0px";

    return item;
  });

  const validationRules = getFormValidations([
    ...newVendorAddressFields,
    ...newVendorContactFields,
  ]);
  const vendorContactFields = newVendorContactFields.map((item) => {
    if (item.name === "corpEmailId") {
      item.initialValue = Cookie.get("email");
    }
    return item;
  });
  const initialFormValues = getInitialFormValues([
    ...newVendorAddressFields,
    ...vendorContactFields,
  ]);

  return (
    <Modal
      show={externalVendorModal}
      onHide={handleClose}
      className="contact_modal"
      size="lg"
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title>{Constants.SELLER_INFORMATION}</Modal.Title>
      </Modal.Header>
      <Col sm={12} md={12} lg={10} xl={12} className="contact_details">
        <Formik
          initialValues={initialFormValues}
          validationSchema={validationRules}
          onSubmit={(values, { setSubmitting }) => {
            setSubmitting(true);
            setSubmitError({ error: false, message: "", type: "" });

            let vendorDetails = {
              firstName: values.firstName,
              lastName: values.lastName,
              corpEmailId: values.corpEmailId,
              jobRole: null,
              country: values.country,
              streetAddress: values.streetAddress,
              city: values.city,
              state: values.state,
              postalCode: values.postalCode,
              phoneNumber: values.phoneNumber,
              extension: values.extension,
              suiteUnitFloor: values.suiteUnitFloor,
              primaryVendorId: null,
              profileType: null,
              isPrimaryVendor: true,
              duns: null,
              merchandiseType: null,
              vendorConnectionPlatform: null,
              certifiedAsMinority: false,
              vendorAddType: null,
              isInternationalSeller: false,
            };
            httpPostAddContactExternalVendor(vendorDetails)
              .then((res) => {
                if (res.status === 201 || res?.data?.success) {
                  window.location = `/boarding/vendor/company`;
                } else {
                  const message = res?.data
                    ? res.data?.error
                      ? res.data?.error?.message
                      : res.data?.message
                    : "Unable to save the details.";

                  setSubmitError({
                    error: true,
                    message,
                  });
                  setSubmitting(false);
                }
              })
              .catch(({ response }) => {
                const message = response?.data
                  ? response.data?.error
                    ? response.data?.error?.message
                    : response.data?.message
                  : "Unable to save the details.";
                setSubmitError({
                  error: true,
                  message,
                });
                setSubmitting(false);
              });
          }}
          render={({
            isSubmitting,
            isValid,
            dirty,
            setFieldValue,
            values,
            resetForm,
          }) => (
            <Form
              data-testid="addNewVendor_form"
              onChange={(e) => {
                const fieldName = e.target.name;
                const fieldValue = e.target.value;
                if (
                  fieldName === "state" ||
                  fieldName === "postalCode" ||
                  fieldName === "country"
                ) {
                  setFieldValue(fieldName, fieldValue.toUpperCase(), true);
                }
                if (fieldName === "phoneNumber") {
                  setFieldValue(fieldName, formatPhone(fieldValue), true);
                }

                if (
                  Constants.ADD_VENDOR_SERVER_ERROR_TYPES.includes(fieldName) &&
                  submitError.type === fieldName
                ) {
                  setSubmitError({ error: false, message: "", type: "" });
                }
                if (
                  submitError.type ===
                  Constants.ADD_VENDOR_SERVER_ERROR_TYPES_MAP.other
                ) {
                  setSubmitError({ error: false, message: "", type: "" });
                }
              }}
            >
              <Row style={{ paddingLeft: "0 !important" }}>
                <Col
                  xl={12}
                  md={12}
                  style={{
                    fontWeight: "bold",
                    paddingLeft: "4px",
                    color: "red",
                  }}
                >
                  {submitError?.message}
                </Col>
              </Row>
              <Row style={{ paddingLeft: "0 !important" }}>
                <Col
                  xl={6}
                  md={6}
                  style={{ fontWeight: "bold", paddingLeft: "4px" }}
                >
                  {Constants.ADDRESS_DETAILS}
                </Col>
                <Col
                  xl={6}
                  md={6}
                  style={{ paddingLeft: "24px", fontWeight: "bold" }}
                >
                  {Constants.CONTACT_DETAILS}
                </Col>
              </Row>
              <Row style={{ gap: "20px" }}>
                <div
                  style={{
                    display: "flex",
                    gap: "0px",
                    width: "50%",
                    flexWrap: "wrap",
                    borderRight: "1px solid #dee2e6",
                    paddingRight: "20px",
                  }}
                >
                  {getFormFields(
                    newVendorAddressFields,
                    setFieldValue,
                    values,
                    setAddressError,
                    addressError,
                    "ext"
                  ).map((field) => field)}
                </div>

                <div
                  style={{
                    display: "flex",
                    gap: "0px",
                    width: "46%",
                    flexWrap: "wrap",
                  }}
                >
                  {getFormFields(newVendorContactFields).map((field) => field)}
                </div>
              </Row>
              <hr style={{ marginTop: "40px" }} />
              <Row>
                <Col xs={12}>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "flex-end",
                      marginTop: "10px",
                    }}
                  >
                    <Button
                      className="button-primary-md"
                      type="submit"
                      disabled={!isValid || !dirty || isSubmitting}
                    >
                      {Constants.BUTTON_SUBMIT}
                    </Button>
                  </div>
                </Col>
              </Row>
            </Form>
          )}
        />
      </Col>
    </Modal>
  );
};

export default ExternalCompanyDetailsModal;
